<template>
  <div class="wt-upload-view">
    <header>
      <img src="/resources/img/googleDrive.svg" width="27" /> &nbsp;&nbsp;
      <div class="wt2-text-l3">
        {{ 'uploadView.title.google' | culture }}
      </div>
    </header>

    <main>
      <div v-if="isEmpty" class="-panel">
        <div class="-empty-files">
          <div class="-center">
            <img src="/resources/img/googleDrive.svg" width="30" />
            <div class="-b wt2-text-m">
              <a href="#" @click.prevent="onBrowse" class="wt2-link">Browse</a>
            </div>
            <div class="-c wt2-text-s">
              <a
                href="#"
                class="wt2-link"
                v-tooltip.extend="{
                  title: $options.supportedTooltip,
                  html: true,
                  placement: 'top',
                  delay: 0,
                  wrapperClass: 'file-upload-wrapper',
                }"
                >Supported Formats</a
              >
            </div>
          </div>
        </div>
      </div>
      <div v-else class="-panel -file-panel">
        <div class="-head">
          <div>{{ 'uploadView.filePanelHead' | culture }}</div>
          <a href="#" @click.prevent="onBrowse" class="wt2-link">Browse</a>
        </div>
        <ul class="-file-list">
          <file-list-record
            v-for="file in model.files"
            :key="file.id"
            :file="file"
            @remove-file-record="onRemoveFileRecord"
          />
        </ul>
      </div>

      <aside class="-panel-divider" />
      <div class="-panel">
        <section>
          <wt-toggle
            class="-privacy-label"
            :label-left="'uploadView.privacyLabel' | culture"
            v-model="model.sharedWithTeam"
          />
        </section>
        <section>
          <wt-text-field
            v-model="model.caption"
            :placeholder="'uploadView.captionPlaceholder' | culture"
            :mandatory="false"
            :maxlength="MAX_TITLE_LENGTH"
          />
        </section>
        <section>
          <wt-text-field
            v-model="model.attribution"
            :placeholder="'uploadView.attributionPlaceholder' | culture"
            :mandatory="false"
            :maxlength="MAX_TITLE_CREDIT_LENGTH"
          />
          <wt-check-box
            class="-attribution-box wt2-text-s"
            v-model="model.attributionMode"
            :disabled="!model.attribution"
            :label-right="'uploadView.attributionMode' | culture"
          />
        </section>
        <section>
          <wt-add-keywords
            theme="black-theme"
            :keyword-height="31"
            :maxRows="4"
            :keywords="model.keywords"
            emptyKeywordsPlaceholder="Add tags"
            @addkeyword="addKeyword"
            @removekeyword="removeKeyword"
          />
        </section>
      </div>
    </main>

    <footer>
      <wt-button
        :disabled="denyUpload"
        type="primary"
        text="Upload"
        @click="onDone"
      />
      <wt-button type="transparent" text="Cancel" @click="closeModal" />
    </footer>

    <aside v-show="waiting" class="-waiting">
      <div class="-center">
        {{ 'uploadView.waiting' | culture }}
        <div class="wt-loader" />
      </div>
    </aside>
  </div>
</template>

<script>
import app from 'app';
import UploadMixin from './UploadMixin.vue';
import FileListRecord from './FileListRecord.vue';

export default {
  mixins: [UploadMixin],
  components: { FileListRecord },

  data() {
    return {
      waiting: false,
      serverError: '',
      model: {
        caption: '',
        files: [],
      },
    };
  },

  props: {
    initFiles: {
      type: Array,
      required: false,
    },
  },

  computed: {
    fileCaption() {
      return this.model.caption.normalizeSpace();
    },

    isEmpty() {
      return _.isEmpty(this.model.files);
    },

    denyUpload() {
      return _.isEmpty(this.model.files);
    },
  },

  created() {
    Object.assign(this.$options, {
      supportedTooltip: `
            <div class="wt2-text-n2" style="margin-bottom: 5px;">
                ${app.culture.get('uploadView.supportTooltipTitle')}
            </div>
            ${tk.context._supportedFileExtensions.join(', ')}
            <div style="margin-top: 10px;">${app.culture.get(
              'uploadView.supportTooltipFooter'
            )}</div>
        `.normalizeSpace(),
    });
  },

  mounted() {
    console.log(this.initFiles);
    this.model.files = this.initFiles;
  },

  methods: {
    onDone() {
      const uqModels = [];

      this.serverError = '';
      this.waiting = true;
      this.$triggerAnalytics('google-drive-upload');

      for (let file, i = 0, I = this.model.files.length; i < I; i++) {
        file = this.model.files[this.model.files.length - i - 1];
        // remove extension
        let title = _.capitalize(file.name.replace(/(.*)\.[^.]+$/g, '$1'));
        if (this.fileCaption.length) {
          if (I > 1) {
            title = `${this.fileCaption}_${i + 1}`;
          } else {
            title = this.fileCaption;
          }
        }

        const request = gapi.client.drive.files.get({
          fileId: file.id,
        });
        request.execute((fileResp) => {
          const data = Object.assign(this.commonData, {
            title,
            downloadRequestOptions: {
              originalFileName: fileResp.originalFilename,
              downloadRequestHeaders: [
                {
                  name: 'Authorization',
                  value: 'Bearer ' + file.downloadToken,
                },
              ],
            },
            fileName: fileResp.downloadUrl,
            metadata: {
              uploadStatus: app.uploadStatus.UPLOAD,
            },
            progress: {},
          });

          const model = new app.namespace.Model.UploadQueueModel(data, {
            urlUpload: true,
          });

          app.UploadQueue.upload(model);
          uqModels.push(model);

          if (uqModels.length === this.model.files.length) {
            this.closeModal({
              uqModels,
              redirectToAssetGallery: true,
            });
          }
        });
      }
    },

    onBrowse() {
      app.namespace.Controller.GoogleDrivePicker.openPicker().then((files) => {
        const concatArray = this.model.files;
        this.model.files.concat(files).forEach((item) => {
          if (!this.model.files.find((modelItem) => item.id === modelItem.id)) {
            concatArray.push(item);
          }
        });
        this.model.files = concatArray;
      });
    },

    onRemoveFileRecord({ file }) {
      const i = this.model.files.indexOf(file);
      if (i >= 0) {
        this.model.files.splice(i, 1);
      }
    },
  },
};
</script>
